import { GiftCards } from '@prisma/client';

export const SORTABLE_KEYS = [
  'customer',
  'purchasedAt',
  'lastUsedAt',
  'currentBalance',
  'expiresAt',
] as const satisfies ReadonlyArray<keyof GiftCards | 'customer'>;
